import { memo, useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
//Local files
import ToolDrawer from 'components/Common/Layout/ToolDrawer/ToolDrawer';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const TextDrawer = ({ open, elementable: oldElementable, onChangeElementable, onClose  }) => {
  const [elementable, setElementable] = useState(null);

  const handleElementableChange = (value) => {
   setElementable(prev => ({ ...prev, ...value }));
   onChangeElementable(value);
  };
  const handleEntering = () => setElementable(oldElementable);
  const handleEnxited = () => setElementable(null);

  return (
    <ToolDrawer
      open={open}
      onClose={onClose}
      SlideProps={{ addEndListener: () => open ? handleEntering() : handleEnxited() }}
    >
      <Box p={3}>
        <Box pb={2}>
          <Typography sx={{ fontWeight: 700, fontSize: '1.5rem'}}>Text</Typography>
        </Box>
        <Box>
          <TextField
            fullWidth
            placeholder='Enter text here'
            multiline
            minRows={4}
            value={elementable?.prompt}
            onChange={({ target: { value: prompt } }) => handleElementableChange({ prompt })}
          />
        </Box>
      </Box>
    </ToolDrawer>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <TextDrawer {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);